import {IconButton, Tooltip} from '@mui/material';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faMoon, faSun} from "@fortawesome/pro-duotone-svg-icons";
import {useTheme} from "@mui/material/styles";
import {useAppTheme} from "@/src/hooks/useAppTheme";

const ThemeToggle = () => {
    const {theme, toggleTheme} = useAppTheme();
    const themeMui = useTheme();
    return (
        <Tooltip title={theme === 'light' ? 'Toggle Dark Mode' : 'Toggle Light Mode'} arrow>
            <IconButton size="large" color="inherit" onClick={toggleTheme}>
                <FontAwesomeIcon
                    icon={theme === 'light' ? faMoon : faSun}
                    size={'sm'}
                    color={themeMui.palette.primary.main}/>
            </IconButton>
        </Tooltip>
    )
};

export default ThemeToggle;
